import React from 'react'
import { Button } from 'reactstrap'
import { sortCaret } from  '../../comum/components/Icones'
import BookingDepotService from '../../../services/BookingDepotService'
import { observable } from 'mobx'
import { buscaFiltrarVazio, buscaSemResultado } from '../../../utils/mensagens';

export default class BookingDepotStore {

    @observable loadingOperacoes;
    @observable operacoes;
    @observable opSelecionada;
    @observable dadosOpSelecionada;

    @observable loadingBookings;
    @observable bookings;

    @observable itens;
    @observable listaDefault;
    @observable loadingDefault;
    @observable loadingModal;

    @observable modalAssocDessoc;
    @observable modo;

    @observable tableMessage;
    @observable alerta;


    constructor() {

        this.operacoes = []
        this.bookings = []
        this.listaDefault = []
        this.defaultBackup = []

        this.itens = null
        this.modo = null
        this.bookingSelecionado = null

        this.opSelecionada = ""
        this.alerta = ""
        this.dadosOpSelecionada = null

        this.loadingModal = false
        this.loadingOperacoes = false
        this.loadingBookings = false
        this.loadingDefault = false
        this.modalAssocDessoc = false
    

        this.colunas = this.todasColunas

        this.service = new BookingDepotService()

        this.tableMessage = buscaFiltrarVazio
    }

    botaoAssociar = (row) => {
        if(row.Associacao && row.Associacao.DepotId !== 0){
            return <Button className="px-2 btn-com-bordas-cinza" onClick={() => this.abrirModalAssoc(row, "Desassoc")}>Desassociar</Button>
        }else{
            return <Button onClick={() => this.abrirModalAssoc(row, "Assoc")} className="px-2 btn-com-bordas-primary">Associar</Button>
        }
    }

    abrirModalAssoc = (booking, modo) => {
        this.modo = modo
        if(this.modo === "AssocDefault") this.defaultBackup = this.listaDefault
        this.bookingSelecionado = booking
        this.modalAssocDessoc = true
    }

    fecharModalAssoc = () => {
        this.modo = null
        this.bookingSelecionado = null
        this.modalAssocDessoc = false
    }

    fecharModalAlerta = () => {
        this.alerta = ""
    }

    listarOperacoes = () => {
        this.loadingOperacoes = true

        this.service.ListarOperacoes().then(response => {
            if(response && response.data) {
                this.operacoes = response.data.map(op => {
                    return ({
                        label: op.NavioViagem,
                        value: op.Oper,
                        NomeNavio: op.NomeNavio,
                        CodViagem: op.CodViagem
                        
                    })
                })
            }
        }).catch(err => console.log(err)
        ).finally(() => {this.loadingOperacoes = false})
    }

    setSelecionarOperacao = (value) => {
        value ? this.opSelecionada = value : this.opSelecionada = ""
        value ? this.dadosOpSelecionada = this.operacoes.find(op => op.Oper === value.Value) : null
    }

    listarBookings = () => {
        this.loadingBookings = true
        this.tableMessage = ""
        this.itens = null

        if(this.opSelecionada !== "") {
            this.service.ListarBooking(this.opSelecionada.value).then(response => {
                if(response && response.data){
                    if(response.data.length === 0) {
                        this.tableMessage = buscaSemResultado
                    } else {
                        this.bookings = response.data
                        
                        //TODO retirar isso quando incluir o infinite scroll
                        this.itens = this.bookings
                    }

                }
            }).catch(err => console.log(err)
            ).finally(() => {this.loadingBookings = false})
        }else{
            this.tableMessage = buscaFiltrarVazio
            this.loadingBookings = false
        }
    }

    listarArmadorDepotDefault = () => {
        this.listaDefault = []
        this.loadingDefault = true
        this.service.ListarArmadorDepotDefault().then(response => {
            if(response && response.data) {
                this.listaDefault = response.data.map((itemDefault, index) => {
                    return(
                        {
                            armador:{
                                label: itemDefault.ArmadorNome,
                                value: itemDefault.ArmadorId
                            },
                            depot:{
                                label: itemDefault.DepotNome,
                                value: itemDefault.DepotId
                            }
                        }
                    )
                })
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingDefault = false)
    }

    salvarDepotDefault = (listaDefault) => {
        this.loadingModal = true
        let listaSalvar = listaDefault.map(item => {
            if((item.armador !== null && item.armador.value !== null) && (item.depot !== null && item.depot.value !== null)){
                return(
                    {
                        "ArmadorId": item.armador.value,
                        "DepotId": item.depot.value
                    }
                )
            } else {
                return null
            }
        })
        listaSalvar = listaSalvar.filter(item => item !== null)
        this.service.SalvarDepotDefaultArmador(listaSalvar).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso === true) {
                    // mensagem de sucesso
                    this.listaDefault = listaDefault.filter(l => l.armador !== null && l.depot !== null)
                    this.listarBookings()
                    this.fecharModalAssoc()
                    this.alerta = "Default alterado com sucesso"
                } else {
                    //mensagem de erro
                    this.alerta = response.data.MensagemErro
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => {
            this.loadingModal = false
        })
    }

    associarBooking = (qtdAssociar, depotAssociado) => {
        this.loadingModal = true
        this.service.AssociarBooking(
            this.bookingSelecionado.Associacao.RbdTipoCntr,
            this.dadosOpSelecionada.CodViagem,
            this.dadosOpSelecionada.NomeNavio,
            qtdAssociar,
            depotAssociado,
            this.bookingSelecionado.EDO.Line,
            this.bookingSelecionado.EDO.Number,
            this.bookingSelecionado.EDO.Gkey,
            this.bookingSelecionado.EDO.EarliestDate,
            this.bookingSelecionado.EDO.LatestDate
        ).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso === true) {
                    // mensagem de sucesso
                    this.listarBookings()
                    this.fecharModalAssoc()
                    this.alerta = "Associação feita com sucesso"
                } else {
                    //mensagem de erro
                    this.alerta = response.data.MensagemErro
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingModal = false)
    }

    desassocicarBooking = (qtdDesassociar) => {
        this.loadingModal = true
        const qtdDesassoc = qtdDesassociar === "" ? 0 : qtdDesassociar
        this.service.DesassociarBooking(this.bookingSelecionado.Associacao.Id, qtdDesassoc).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso === true) {
                    // mensagem de sucesso
                    this.listarBookings()
                    this.fecharModalAssoc()
                    this.alerta = "Desassociação feita com sucesso"
                } else {
                    //mensagem de erro
                    this.alerta = response.data.MensagemErro
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingModal = false)
    }

    todasColunas = [
        {
            text: "Booking",
            dataField: "EDO.Number",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left'
        },
        {
            text: "Tipo cntr",
            dataField: "Associacao.RbdTipoCntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left'
        },
        {
            text: "Qtd cntr",
            dataField: "Associacao.RbdQtdCntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left'
        },
        {
            text: "Depot associado",
            dataField: "Associacao.ApelidoDepot",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left'
        },
        {
            text: "Ação",
            dataField: "acao",
            sort: true,
            typeButton: "Ação",
            buttonOnclick: this.abrirModalAssoc,
            sortCaret: sortCaret,
            formatter: (cell, row) => this.botaoAssociar(row)
        },
    ]

}


// WEBPACK FOOTER //
// ./src/modules/bookingdepot/stores/BookingDepotStore.js